<div class="error-toast">
  <p class="">
    Looks like you have an active pass! Refresh this page to see the latest info
    and continue enjoying your current pass before buying a new one.
  </p>
  <button mat-button color="primary" size="small" (click)="onClick()">
    Refresh
  </button>
</div>
